import { useField } from 'formik';

import type { FieldHookConfig } from 'formik';

const HiddenInput = ({ ...props }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field] = useField(props as FieldHookConfig<any>);

  return (
    <input {...field} {...props} type="hidden" />
  );
};

export default HiddenInput;
